import React from 'react';
import { Col, Panel, Row } from 'react-bootstrap';

import JobTypeCapacity from './JobTypeCapacity';

const JobTypeCapacities = ({ jobTypes, events }) => {
  // Group the job types by name for quick lookup
  const jobTypesByName = jobTypes
    .reduce((types, t) => ({ ...types, [t.name]: t }), {});

  // Group events by job type
  const eventsByJobType = events
    .filter(e => e.job && !e.tentative && e.job.jobType && jobTypesByName[e.job.jobType])
    .reduce((types, e) => ({
      ...types,
      [e.job.jobType]: [
        ...(types[e.job.jobType] || []),
        e
      ]
    }), {});

  return (
    <Panel bsStyle="default" defaultExpanded>
      <Panel.Toggle componentClass={Panel.Heading}>
        <Panel.Title>Job Types</Panel.Title>
      </Panel.Toggle>
      <Panel.Collapse>
        <Panel.Body>
          {Object.keys(eventsByJobType).length
            ? (
              <Row>
                {Object.keys(eventsByJobType)
                  .map((jobType) => (
                    <Col md={4} key={jobType}>
                      <JobTypeCapacity
                        jobType={jobTypesByName[jobType]}
                        events={eventsByJobType[jobType]}
                      />
                    </Col>
                  ))
                }
              </Row>
            )
            : (
              <blockquote>No jobs are scheduled today</blockquote>
            )}
        </Panel.Body>
      </Panel.Collapse>
    </Panel>
  );
};

export default JobTypeCapacities;
